export default {
  title: 'Ruokalistan muokkaushistoria',
  subtitle: 'Katso, kuka muutti hintoja, saatavuutta ja näkyvyyttä kohteelle {{company}} — ja milloin.',
  filters: {
    type: {
      label: 'Tyyppi',
    },
    item: {
      placeholder: 'Kaikki kohteet',
    },
    event: {
      label: 'Tapahtuma',
    },
  },
  columns: {
    when: 'Milloin',
    who: 'Muuttanut',
    type: 'Tyyppi',
    item: 'Kohde',
    event: 'Tapahtuma',
    changes: 'Muutokset',
  },
  types: {
    product: 'Tuote',
    modifier: 'Muokkain',
  },
  events: {
    created: 'Luotu',
    updated: 'Päivitetty',
    deleted: 'Poistettu',
  },
  fields: {
    name: 'Nimi',
    description: 'Kuvaus',
    price: 'Hinta',
    is_available: 'Saatavuus',
    is_visible: 'Näkyvyys',
    is_available_for_pickup: 'Nouto saatavilla',
    is_available_for_delivery: 'Toimitus saatavilla',
  },
  booleans: {
    on: 'Saatavilla',
    off: 'Ei saatavilla',
  },
  pagination: {
    previous: 'Edellinen',
    next: 'Seuraava',
  },
  causers: {
    orders_terminal: 'Tilauspääte',
  },
  system: 'Järjestelmä',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Valikon muokaushistorian lataaminen epäonnistui',
  },
};
